export default __webpack_public_path__ + "images/bs-5497678a4578b848e08d70e77484bbad.svg";